import type { PropsWithChildren } from 'react';

import { UploadFileContainerStyled } from './styles/UploadFileContainerStyled'
import { type UploadFile as UploadFileInterface } from '../../types'
import { type UploadCommonProps } from '../../Upload'
import { getAnalyticsDataAttrs } from '@ui/utils/analytics'

export interface IUploadFileContainerProps {
  commonProps: UploadCommonProps
  innerProps: {
    file: UploadFileInterface
  }
}

export const UploadFileContainer = (
  props: PropsWithChildren<IUploadFileContainerProps>
) => {
  const {
    commonProps: { uploadProps },
    ...otherProps
  } = props

  const analyticsProps = getAnalyticsDataAttrs(
    uploadProps.analyticsIds?.uploadFileContainer
  )

  return <UploadFileContainerStyled {...analyticsProps} {...otherProps} />
}
